import { Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import GeneralDetailsStep from 'components/WizardViews/SalaryComponents/CreatePerquisites/GeneralDetailsStep';
import ReviewStep from 'components/WizardViews/SalaryComponents/CreatePerquisites/ReviewStep';
import {
  createPerquisitesRouteToStepMap,
  perquisitesSteps,
} from 'components/WizardViews/SalaryComponents/constants';
import { WizardHeader, WizardProgressView, WizardWrapper } from 'components/WizardViews/components';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { Wizard, WizardStep } from 'forms/Wizard';
import { FormProvider } from 'forms';
import React from 'react';
import { useHistory } from 'react-router-dom';

const CreatePerquisitesForm = () => {
  const history = useHistory();

  const handleCloseClick = () => {
    history.push(routePaths.salaryComponents.root);
  };

  return (
    <WizardInfoProvider initialStep={0} totalSteps={2}>
      <WizardPathToStepController routeStepMap={createPerquisitesRouteToStepMap} />
      <WizardWrapper>
        <WizardHeader
          heading="New"
          subHeading="Perquisite Component"
          onCloseClick={handleCloseClick}>
          <WizardProgressView
            steps={[
              { label: 'General', position: perquisitesSteps.step1 },
              { label: 'Review', position: perquisitesSteps.step2 },
            ]}
          />
        </WizardHeader>
        <FormProvider>
          <Box flex={1} overflowY="auto" height="100%">
            <Wizard>
              <WizardStep step={perquisitesSteps.step1} component={GeneralDetailsStep} />
              <WizardStep step={perquisitesSteps.step2} component={ReviewStep} />
            </Wizard>
          </Box>
        </FormProvider>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default CreatePerquisitesForm;
